import React from 'react';
import { MapPinIcon, StarIcon } from 'lucide-react';
type Testimonial = {
  initials: string;
  name: string;
  location: string;
  role: string;
  quote: string;
};
export function TestimonialCard({
  testimonial
}: {
  testimonial: Testimonial;
}) {
  return <figure className="glass flex h-full flex-col p-5 text-left" data-id="element-240" data-mp="2kevjh1f7onpa">
      <div className="flex items-center gap-0.5 text-gold" aria-label="Calificación 5 de 5" data-id="element-241" data-mp="2p8huyq9n2lji">
        {Array.from({
        length: 5
      }).map((_, index) => <StarIcon key={index} className="h-3 w-3 fill-current" aria-hidden="true" data-id="element-242" data-mp="2z5m860lib6o6" data-mpi={index} />)}
      </div>
      <blockquote className="mt-3 flex-1 text-[14px] italic leading-[1.6] text-ice" data-id="element-243" data-mp="344z378mj7k1u">
        “{testimonial.quote}”
      </blockquote>
      <figcaption className="mt-4 flex items-center gap-3 border-t border-line pt-4" data-id="element-244" data-mp="385j1ifiuctpk">
        <span className="flex h-8 w-8 shrink-0 items-center justify-center rounded-full border border-gold/30 bg-line text-[11px] font-bold tracking-[0.05em] text-gold" data-id="element-245" data-mp="19rpsjdi91si0">
          {testimonial.initials}
        </span>
        <span className="min-w-0" data-id="element-246" data-mp="htme3uqknx38">
          <span className="block truncate text-[13px] font-semibold text-ice" data-id="element-247" data-mp="huxhvuk0p4uc">
            {testimonial.name}
          </span>
          <span className="mt-0.5 flex items-center gap-1.5 text-[12px] text-cool" data-id="element-248" data-mp="82rpwktrmnf5">
            <MapPinIcon className="h-3 w-3 shrink-0" aria-hidden="true" data-id="element-249" data-mp="33ycesehawez" />
            <span className="truncate" data-id="element-250" data-mp="35rju9wx1ko1">
              {testimonial.location} · {testimonial.role}
            </span>
          </span>
        </span>
      </figcaption>
    </figure>;
}